module.exports = __webpack_public_path__ + "static/media/warning-triangle-white.80f219a8.svg";